// extracted by mini-css-extract-plugin
module.exports = {"colorsGrid":"styles_colorsGrid__3s4Oo","color":"styles_color__2IQjU"};